/**
 * Main App component with routing and authentication
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import './App.css';

// Import pages
import Login from './pages/Login';
import AuthCallback from './components/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';

// Role-based architecture pages
import Roles from './pages/Roles';
import CreateRole from './pages/CreateRole';
import RoleDetails from './pages/RoleDetails';
import RoleCandidates from './pages/RoleCandidates';
import RoleUpload from './pages/RoleUpload';
import ResumeBank from './pages/ResumeBank';

function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

            {/* Protected routes */}
            <Route
              path="/"
              element={<Navigate to="/roles" replace />}
            />

            {/* Role-based architecture routes */}
            <Route
              path="/roles"
              element={
                <ProtectedRoute>
                  <Roles />
                </ProtectedRoute>
              }
            />
            <Route
              path="/roles/new"
              element={
                <ProtectedRoute>
                  <CreateRole />
                </ProtectedRoute>
              }
            />
            <Route
              path="/roles/:roleId"
              element={
                <ProtectedRoute>
                  <RoleDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/roles/:roleId/candidates"
              element={
                <ProtectedRoute>
                  <RoleCandidates />
                </ProtectedRoute>
              }
            />
            <Route
              path="/roles/:roleId/upload"
              element={
                <ProtectedRoute>
                  <RoleUpload />
                </ProtectedRoute>
              }
            />
            <Route
              path="/resume-bank"
              element={
                <ProtectedRoute>
                  <ResumeBank />
                </ProtectedRoute>
              }
            />

            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
